// src/components/GoogleLoginButton.jsx
import React from "react";
import { auth, googleProvider, signInWithPopup } from "../firebase";
import { doc, getDoc, setDoc, serverTimestamp, increment } from "firebase/firestore";
import { db } from "../firebase";

export default function GoogleLoginButton({ onLoginSuccess }) {
  
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      let userData;

      if (userSnap.exists()) {
        const existingData = userSnap.data();
        const pointsToAdd = 2; // Always add 2 points on every login

        const updateData = {
          lastLogin: serverTimestamp(),
          points: increment(pointsToAdd)
        };

        await setDoc(userRef, updateData, { merge: true });
        
        userData = { 
          ...existingData, 
          ...updateData, 
          points: (existingData.points || 0) + pointsToAdd,
          lastLogin: new Date() 
        };
      } else {
        // Brand new user: give initial 2 points for joining/first login
        userData = {
          uid: user.uid,
          name: user.displayName || "",
          email: user.email || "",
          photoURL: user.photoURL || "",
          username: "",
          location: "",
          organization: "",
          role: "Student",
          points: 2, 
          streak: 1,
          badges: [],
          joinedAt: serverTimestamp(),
          lastLogin: serverTimestamp(),
        };
        await setDoc(userRef, userData);
        
        userData.joinedAt = new Date();
        userData.lastLogin = new Date();
      }

      if (onLoginSuccess) {
        onLoginSuccess(userData);
      }
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  };

  return (
    <button
      onClick={handleGoogleLogin}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        backgroundColor: "#ffffff",
        color: "#374151",
        border: "1px solid #d1d5db",
        padding: "10px 20px",
        borderRadius: "24px",
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        transition: "background 0.2s"
      }}
    >
      <img
        src="https://www.svgrepo.com/show/475656/google-color.svg"
        alt="Google logo"
        style={{ width: "18px", height: "18px" }}
      />
      Continue with Google
    </button>
  );
}